// Clamp a numeric "build progress" value into the 0..100 window so a stale
// or malformed row (NaN, negative, >100 from a future field-rename) can't
// blow a CSS-width-driven progress bar past its container.
export function clampProgress(p: number): number {
  if (!Number.isFinite(p)) return 0
  return Math.max(0, Math.min(100, p))
}
